import { useDependencies } from '@servicetitan/react-ioc';
import { SetupDataStore } from '../stores/setupDataStore';
import { FinancingApi, TenantsGetSettingsData } from '@servicetitan/financing-api-client';
import { useQuery } from '@tanstack/react-query';

export const useTenantSettings = (): TenantsGetSettingsData | undefined => {
    const { setupData } = SetupDataStore.useStore();
    const [apiClient] = useDependencies(FinancingApi);

    const settingsResult = useQuery({
        queryKey: ['tenantSettings', setupData?.tenantId],
        queryFn: () => apiClient.tenantsGetSettings(setupData?.tenantId ?? ''),
        enabled: !!setupData?.tenantId,
        staleTime: 5 * 60 * 1000,
    });

    return settingsResult.data?.data;
};
